import { useCallback, useEffect, useState } from 'react';
import { RxCube } from 'react-icons/rx';
import { RoomObjectType } from '../../types/room';
import { UserObjectType } from '../../types/user';
import { cssBackground, formatRoomName } from '../../utils/room_utils';
import { useSearchContext } from '../../context/SearchContext';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const SuggestedRoom = ({
  room,
  navigate,
}: {
  room: RoomObjectType;
  navigate: () => void;
}) => {
  const onClickHandler: React.MouseEventHandler = useCallback(
    function (e) {
      e.stopPropagation();
      e.preventDefault();
      navigate();
    },
    [navigate]
  );

  return (
    <div
      className="suggested-room"
      onClick={onClickHandler}
      style={cssBackground(room)}
    >
      <div className="name">{formatRoomName(room)}</div>
    </div>
  );
};

const RoomName = ({
  room,
  index,
  navigate,
}: {
  room: RoomObjectType;
  index: number;
  navigate: () => void;
}) => {
  const onClickHandler: React.MouseEventHandler = useCallback(
    function (e) {
      e.stopPropagation();
      e.preventDefault();
      navigate();
    },
    [navigate]
  );

  return (
    <div
      className={`nft-name ${index === 0 ? 'active' : ''}`}
      onClick={onClickHandler}
    >
      <RxCube />
      {formatRoomName(room)}
    </div>
  );
};

const SearchResults = ({
  results,
  suggested,
  handleNavigateToSelectedNft,
  filtersVisible,
}: {
  results: RoomObjectType[];
  suggested: RoomObjectType[];
  handleNavigateToSelectedNft: (room: RoomObjectType) => void;
  filtersVisible: boolean;
}) => {
  const [selectedAuthor, setSelectedAuthor] = useState<
    UserObjectType | undefined
  >(undefined);

  const [userNFTs, setUserNFTs] = useState<RoomObjectType[]>([]);
  const { searchFetching } = useSearchContext();

  useEffect(() => {
    setSelectedAuthor(undefined);
    setUserNFTs([]);
  }, [results]);

  return (
    <div
      className={`search-results-container ${
        filtersVisible ? 'filters-visible' : ''
      }`}
    >
      <div className="nft-results">
        <div className="section-header">Rooms</div>
        {results.map((res, index) => (
          <RoomName
            room={res}
            navigate={() => handleNavigateToSelectedNft(res)}
            index={index}
            key={index + '-' + res.roomId}
          />
        ))}
        {searchFetching && (
          <AiOutlineLoading3Quarters
            color="white"
            size={20}
            className="loading-icon"
            style={{ width: 20, height: 20 }}
          />
        )}
        {!searchFetching && !results.length && (
          <p>Found no rooms matching your search query.</p>
        )}
      </div>
      {/* TODO: add authors to rooms (API doesn't return this yet.) */}
      {/* <div className="user-results">
        <div className="section-header">Users</div>
        {results
          .filter((result) => result.author)
          .filter((v, i, a) =>
            a.findIndex(
              (v2) => v2.author?.wallet_address === v.author?.wallet_address,
              i
            )
          )
          .map((result, index) => (
            <div
              key={index + '-' + result.displayName}
              className={`user-name ${
                selectedAuthor?.wallet_address === result.author?.wallet_address
                  ? 'selected'
                  : ''
              }`}
              onClick={() => onUserClick(result.author)}
            >
              <BiUser />
              {result.author?.user_name}
            </div>
          ))}
      </div> */}
      <div className="suggested-rooms">
        <div className="section-header big">
          {userNFTs.length === 0
            ? 'Suggested rooms'
            : `Rooms by: ${selectedAuthor?.user_name}`}
        </div>
        <div className="suggested-rooms-container">
          {userNFTs.length === 0 &&
            suggested.length > 0 &&
            suggested.map((res) => (
              <SuggestedRoom
                room={res}
                navigate={() => handleNavigateToSelectedNft(res)}
                key={'suggested-' + res.roomId}
              />
            ))}
          {userNFTs.length > 0 &&
            userNFTs.map((res) => (
              <SuggestedRoom
                room={res}
                navigate={() => handleNavigateToSelectedNft(res)}
                key={'suggested-' + res.roomId}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
